export default "__VITE_ASSET__$Ur6ub5i__"